import React from 'react';
import { Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../../../../../../../shared/functions/Functions';
import { CustomImageHandler } from '../../../../../../../../shared/components/CustomImageHandler';
import { User } from '../../../../../../../../model/user/User';

interface IProposalReviewInfoProps {
    isApproved?: boolean;
    isDeclined?: boolean;
    isConvertedToOffer?: boolean;
    proposalDeclineReason?: string;
    proposalReviewedBy?: User;
    updatedAt?: string;
}

export function ProposalReviewInfo({
    isApproved,
    isDeclined,
    isConvertedToOffer,
    proposalDeclineReason,
    proposalReviewedBy,
    updatedAt,
}: IProposalReviewInfoProps) {
    const { t } = useTranslation();

    if (!isApproved && !isDeclined) {
        return null;
    }

    const reviewerName =
        proposalReviewedBy?.displayName || `${proposalReviewedBy?.firstName ?? ''} ${proposalReviewedBy?.lastName ?? ''}`;

    return (
        <Row
            className={`booking-card m-0 position-relative p-3 mb-3 mt-2 ${
                isApproved ? 'border-success' : 'border-danger'
            }`}
        >
            <div className="d-flex align-items-center justify-content-between px-0">
                <div className="d-flex align-items-center gap-2 flex-shrink-0">
                    <CustomImageHandler
                        altTag="User Profile"
                        thumbnailPath={proposalReviewedBy?.profilePhoto?.thumbnail}
                        photoPath={proposalReviewedBy?.profilePhoto?.path}
                        name={reviewerName}
                        classes="user-img-rounded image-40"
                    />
                    <div className="text-nowrap">
                        <p className="mb-0 text-muted">
                            {isApproved
                                ? t('brand.campaign.book.offer.approved_by')
                                : t('brand.campaign.book.offer.declined_by')}
                        </p>
                        <h6 className="mb-0">
                            {reviewerName || '-'}
                        </h6>
                    </div>
                </div>
                {isDeclined && proposalDeclineReason && (
                    <div className="text-center mx-3">
                        <p className="mb-0 text-muted">
                            {t('brand.campaign.book.offer.proposal_decline_reason')}
                        </p>
                        <p className="mb-0">
                            {proposalDeclineReason}
                        </p>
                    </div>
                )}
                {isApproved && isConvertedToOffer && (
                    <div className="d-flex align-items-center gap-2 mx-3 flex-shrink-0">
                        <CustomImageHandler
                            altTag="Offer sent"
                            photoPath="/icons/approved-icon.svg"
                            classes="user-img-rounded image-30"
                        />
                        <div className="text-nowrap">
                            <p className="mb-0">
                                {t('brand.campaign.book.offer.offer_sent_tooltip')}
                            </p>
                        </div>
                    </div>
                )}
                <div className="text-end flex-shrink-0">
                    <p className="mb-0 text-muted">
                        {isApproved
                            ? t('brand.campaign.book.offer.approval_date')
                            : t('brand.campaign.book.offer.decline_date')}
                    </p>
                    <p className="mb-0 text-muted">
                        {updatedAt ? formatDate(updatedAt) : ''}
                    </p>
                </div>
            </div>
        </Row>
    );
}

export default ProposalReviewInfo;
